import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../material-ui/Button';
import { MenuItem } from '../material-ui/Menu/MenuItem';
import { useLanguageToggle } from './useLanguageToggle';
import { useStyles } from './useStyles';
import { Typography } from '../material-ui/Typography';

export const LanguageSelector = memo(({ isMenu = false, variant, classListItem }) => {
    const { t: translate } = useTranslation();
    const { currentLanguage, handleToggleLanguage } = useLanguageToggle();
    const classes = useStyles();

    return isMenu ? (
        <MenuItem onClick={handleToggleLanguage} className={classListItem}>
            <Typography className={classes.icon}>{currentLanguage.toUpperCase()}</Typography>
            <Typography className={classes.text}>{translate && translate('currentLang')}</Typography>
        </MenuItem>
    ) : (
        <Button onClick={handleToggleLanguage} className={classes.button} {...(variant && { variant })} color="primary">
            {currentLanguage.toUpperCase()}
        </Button>
    );
});
